import { useEffect, useRef } from 'react';

const useInterval = (callback: () => void, delay: number | null) => {
  const timeoutRef = useRef<any>(null);
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (typeof delay === 'number') {
      const tick = () => savedCallback.current();
      timeoutRef.current = setInterval(tick, delay);
    }
    return () => clearInterval(timeoutRef.current);
  }, [delay]);

  return timeoutRef;
};

export default useInterval;
